import { findPeople } from 'owa-recipient-common/lib/services/findPeople';
import { SubstrateSearchSuggestionsResponse } from 'owa-search-service';
import FindPeopleResponseMessage from 'owa-service/lib/contract/FindPeopleResponseMessage';
import substrateSuggestions from 'owa-substrate-people-suggestions/lib/services/substrateSuggestions';
import shouldUse3SPeopleSuggestions from 'owa-substrate-people-suggestions/lib/utils/shouldUse3SPeopleSuggestions';

export type SuggestionService = (
    queryString: string,
    includeDirectory: boolean,
    includeFeatureData?: boolean,
    includeImplicitGroups?: boolean,
    currentRecipients?: string[]
) => Promise<FindPeopleResponseMessage | SubstrateSearchSuggestionsResponse>;

export function getSuggestionsService(): SuggestionService {
    if (shouldUse3SPeopleSuggestions()) {
        return substrateSuggestions;
    } else {
        return findPeople;
    }
}
